export default {
  primary: '#00A0DC',
  secondary: '#EB0019',
  accent: '#61d1ff',
  error: '#b00000',
  info: '#00A0DC',
  success: '66c530',
  warning: '#F07D0F',
  anchor: '#00A0DC'
}
